import(/* webpackMode: "eager", webpackExports: ["LiveMarkets"] */ "/vercel/path0/src/components/shared/LiveMarkets.tsx");
